<template>
  <div
    class="sitebuilder-element-container"
    element="SocialBarComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :style="style()"
  >
    <div :style="`transform: rotate(${this.$props.device === 'desktop' ? this.internal_config.rotation : 0}) scale(1)`">

      <div v-bind:style="{'border-radius': radius,border : border}">
        <div id="socialId"
          class="embed-responsive embed-responsive-16by9 socialbar-parent"
          v-bind:style="getOrientation()"
        >
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkFacebook"
            :href="getUrl('Facebook')"
            rel="noreferrer" @click="linkAnchorForce"
          >
            <img :src="getSrc('Facebook')" class="socialbar-icon" />
          </a>
          <a class="socialbar-div" v-if="this.internal_config.checkTwitter" :href="getUrl('Twitter')" @click="linkAnchorForce">
            <img :src="getSrc('Twitter')" class="socialbar-icon" />
          </a>
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkInstagram"
            :href="getUrl('Instagram')"
            rel="noreferrer" @click="linkAnchorForce"
          >
            <img :src="getSrc('Instagram')" class="socialbar-icon" />
          </a>
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkLinkedin"
            :href="getUrl('Linkedin')"
            rel="noreferrer" @click="linkAnchorForce"
          >
            <img :src="getSrc('Linkedin')" class="socialbar-icon" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Model from "./Model";

export default {
  name: "SocialBarComponent",
  components: {
    Model,
  },
  props: ["config", "height_start", "device", "id", "preview"],
  data() {
    return Model.data();
  },
  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
  methods: {
    animation() {
      return true;
    },
    rebuild() {
      let vm = this;
      let config = this.internal_config;
      this.internal_config = {};
      this.$nextTick(() => {
        vm.internal_config = config;
        this.$root.$emit("rSidebarEdition", vm);
      });
    },
    getUrl(type) {
      if (type == "Facebook") {
        return this.internal_config.sbFacebook;
      }
      if (type == "Twitter") {
        return this.internal_config.sbTwitter;
      }
      if (type == "Instagram") {
        return this.internal_config.sbInstagram;
      }
      if (type == "Linkedin") {
        return this.internal_config.sbLinkedin;
      }
    },
    getOrientation() {
      let { orientation } = this.internal_config;

      orientation = orientation ? "block" : "inline-flex";
      return `display: ${orientation}`;
    },
    getSrc(type) {
      return this.internal_config[`image${type}`]
        ? this.internal_config[`image${type}`]
        : "vazio";
    },

    showResources() {
    },
    callReorder(idx) {
      this.$parent.changeOrderPanel(this, idx);
    },
    //change order on html
    changeOrderPanel(elem, idx) {
      let id = elem.$el.id,
        sibling =
          idx === 1
            ? document.getElementById(id).nextSibling
            : document.getElementById(id).previousSibling;

      if (sibling === null) {
        return true;
      }

      let vm = this;
      this.$root.$emit("changeOrderElementsInside", vm.id, id, sibling.id, idx);
    },
    handler: function(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit("handlerElement", this);
      e.stopPropagation();
      e.preventDefault();
    },
    style() {
      let {
        width,
        left,
        zIndex,
        paddingTop,
        paddingLeft,
        paddingRight,
        paddingBottom,
        top,
        rotation
      } = this.internal_config;

      let style = `  width: ${width};
                     left:  ${left};
                     z-index: ${zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${paddingTop};
                     padding-left: ${paddingLeft};
                     padding-right: ${paddingRight};
                     padding-bottom: ${paddingBottom};
           top: ${top};
           transform: rotate(${this.$props.device == 'desktop' ? rotation : 0}) scale(1)`;

      return style;
    },
    saveElementDefault() {
      this.$root.$emit("saveElement", this);
    },
    alignElement(axis) {
      this.$root.$emit("alignElement", this, axis);
    },

    linkAnchorForce(){
      this.$root.$emit("linkAnchorForce");
    }
  },
  created() {
    let device, childs, id, config;
    ({ device, childs, id, config } = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== "undefined") {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    if(this.internal_config.sbNewAba){
    $('#socialId a').click(function() {
    $(this).attr('target', '_blank');
})
    };

    this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");
    
   
    let objIds = [];
    $("[id]").each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.socialbar-parent:before {
  content: none;
}

.socialbar-div {
  height: auto;
  width: 100%;
}

.socialbar-icon {
  height: auto;
  width: 100%;
}

.vdr {
  height: auto !important;
}

.preview-img {
  width: 100%;
  height: auto;
}
[data-device="mobile"] .socialbar-parent {
 display: inline-flex !important;
 }
</style>
